import React, { Component } from 'react';
import { WithTranslation } from 'react-i18next';
import Table from 'components/Table';
import { UserTaskHistory } from '#shared/types/task';
import { ColumnDefinition, FilterParams, ListItem } from '#web-components/types/table';
import { dateTimeFormatter } from '#web-components/utils';
import FolderIcon from '#web-components/components/Icons/FolderIcon';

interface CompletedTasksTableProps extends WithTranslation {
  tasksList: UserTaskHistory[],
  getCompetedTasksList: (filterParams: FilterParams, isInitialRequest?: boolean) => void,
  filterParams: FilterParams,
  isLoadingTasks: boolean,
}

export default class CompletedTasksTable extends Component<CompletedTasksTableProps> {
  // eslint-disable-next-line react/sort-comp
  localizedDateFormatter = (prop: string) => (listItem: ListItem) => dateTimeFormatter(
    listItem,
    prop,
    this.props.i18n.language,
  );

  columnDefinitions: ColumnDefinition[] = [
    {
      title: this.props.t('tasksList.components.completedTasksTable.columns.processDefinitionName'),
      property: 'processDefinitionName',
      width: 408,
      sortable: false,
    },
    {
      title: this.props.t('tasksList.components.completedTasksTable.columns.businessKey'),
      property: 'businessKey',
      width: 408,
      sortable: false,
    },
    {
      title: this.props.t('tasksList.components.completedTasksTable.columns.name'),
      property: 'taskDefinitionName',
      width: 352,
      sortable: false,
    },
    {
      title: this.props.t('tasksList.components.completedTasksTable.columns.dateCreated'),
      property: 'startTime',
      formatter: this.localizedDateFormatter('startTime'),
      width: '204px',
    },
    {
      title: this.props.t('tasksList.components.completedTasksTable.columns.dateCompleted'),
      property: 'endTime',
      formatter: this.localizedDateFormatter('endTime'),
      width: '204px',
    },
  ];

  componentDidMount() {
    const { getCompetedTasksList, filterParams } = this.props;
    getCompetedTasksList(filterParams, true);
  }

  handleFilterChange = (filterParams: FilterParams) => {
    const { getCompetedTasksList } = this.props;
    getCompetedTasksList(filterParams, false);
  };

  render() {
    const {
      tasksList,
      t,
      isLoadingTasks,
      filterParams: {
        page,
        rowsPerPage,
        order,
        orderField,
      },
    } = this.props;
    return (
      <Table
        columnDefinitions={this.columnDefinitions}
        onFilterChange={this.handleFilterChange}
        list={tasksList}
        order={order}
        orderField={orderField}
        pagination={{
          page,
          rowsPerPage,
        }}
        emptyPlaceholderIcon={<FolderIcon size={28} />}
        emptyPlaceholder={t('tasksList.components.completedTasksTable.emptyPlaceholder')}
        hideEmptyPlaceholder={isLoadingTasks}
        dataXpathTableRowPropName="processInstanceId"
      />
    );
  }
}
